<script setup>
  import AppModal from '@/components/ui/overlays/AppModal.vue'
  import AuthRepository from '@/repositories/AuthRepository'
  import { useAuthStore } from '@/stores/useAuthStore'

  const authStore = useAuthStore()
  const user = authStore

  const handleAcceptClicked = () => {
    AuthRepository.markPaymentPopupAsSeen().then((response) => {
      authStore.setUserData({
        ...response.data,
      })
    })
  }
</script>

<template>
  <app-modal
    :model-value="user.showPaymentPopup"
    title="Profiteia is officieel live!"
    title-class="text-lg"
    size="lg"
    :show-close="false"
    :close-on-backdrop="false"
    :close-on-escape="false"
    confirm-label="Oké"
    confirm-tone="primary"
    @confirm="handleAcceptClicked"
  >
    <p>
      Sinds 6 augustus is Profiteia <b>officieel live</b> als betaald platform. We hebben krachtige
      nieuwe functionaliteiten gelanceerd, waaronder <b>real-time alerts</b> die je direct
      waarschuwen bij belangrijke marktveranderingen, én <b>unieke tools</b> die jou helpen om
      sneller en slimmer beslissingen te nemen op basis van jouw flexibiliteit. Zo haal je nog meer
      waarde uit jouw energie-inzichten.
      <br />
      <br />
      We kijken ernaar uit om samen met jou verder te bouwen aan het meest geavanceerde
      energie-dataplatform van Europa.
      <br />
      <br />
      📩 Heb je vragen? Stuur ons een bericht via
      <a href="mailto:info@profiteia.nl">info@profiteia.nl</a>
    </p>
  </app-modal>
</template>
